(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function closeDialog(dialog) {
    if(!dialog||dialog.dataset.closing)return;
    if(reduced.matches){dialog.close();return;}
    dialog.dataset.closing='true';
    const mobile=matchMedia('(max-width:749px)').matches;
    const animation=dialog.animate([{opacity:1,transform:'translate(0)'},{opacity:0,transform:mobile?'translateY(20px)':'translateX(20px)'}],{duration:150,easing:'ease-in'});
    animation.finished.then(()=>dialog.close()).catch(()=>{}).finally(()=>delete dialog.dataset.closing);
  }
  const openDialog = id => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    dialog.showModal();
  };
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) openDialog(opener.dataset.dialogOpen);
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closeDialog(closer.closest('dialog'));
    const cartLink = event.target.closest('[data-cart-open]');
    if(cartLink && document.getElementById('FramesCartDrawer')) {event.preventDefault();openDialog('FramesCartDrawer');}
    const galleryButton=event.target.closest('[data-gallery-target]');
    if(galleryButton){const gallery=galleryButton.closest('[data-gallery]');gallery.querySelectorAll('[data-gallery-slide]').forEach(s=>{s.hidden=s.dataset.gallerySlide!==galleryButton.dataset.galleryTarget;if(s.hidden)s.querySelectorAll('video').forEach(v=>v.pause());});gallery.querySelectorAll('[data-gallery-target]').forEach(b=>b.setAttribute('aria-pressed',String(b===galleryButton)));}
  });
  document.addEventListener('cancel',event=>{if(event.target.matches('dialog')){event.preventDefault();closeDialog(event.target);}},true);
  document.addEventListener('keydown', event=>{if(event.key==='Escape') document.querySelectorAll('.f-header__dropdown[open]').forEach(d=>{if(d.contains(document.activeElement))d.querySelector('summary').focus();d.open=false;});});
  document.addEventListener('focusin',event=>{document.querySelectorAll('.f-header__dropdown[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;});});
  document.addEventListener('click',event=>{document.querySelectorAll('.f-header__dropdown[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;});});
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-auto-submit]'))event.target.form.requestSubmit();
  });
  document.addEventListener('input', event=>{
    if(!event.target.matches('[data-faq-search]'))return;
    const section=event.target.closest('[data-faq-section]'), query=event.target.value.toLocaleLowerCase().trim();let matches=0;
    section.querySelectorAll('.f-faq__item').forEach(item=>{item.hidden=!item.textContent.toLocaleLowerCase().includes(query);if(!item.hidden)matches++;});
    section.querySelector('[data-faq-empty]').hidden=matches>0;
    section.querySelectorAll('[data-faq-group]').forEach(group=>{group.hidden=![...group.querySelectorAll('.f-faq__item')].some(item=>!item.hidden);});
  });
  document.addEventListener('click',event=>{
    const control=event.target.closest('[data-slide-index],[data-slide-prev],[data-slide-next]');if(!control)return;
    const carousel=control.closest('[data-slideshow]'),slides=[...carousel.querySelectorAll('[data-slide]')],current=slides.findIndex(s=>!s.hidden);
    let index=control.dataset.slideIndex!==undefined?Number(control.dataset.slideIndex):current+(control.hasAttribute('data-slide-prev')?-1:1);
    index=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);carousel.querySelectorAll('[data-slide-index]').forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));
  });
  document.addEventListener('play',event=>{if(event.target.tagName==='VIDEO')document.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause();});},true);
  let headerAbort,headerObserver;
  function initializeHeader(){
    headerAbort?.abort();headerObserver?.disconnect();
    const header=document.querySelector('[data-frame-header]');if(!header)return;
    headerAbort=new AbortController();
    const section=header.closest('.shopify-section'),announcement=section?.querySelector('.f-announcement');
    const measure=()=>section?.style.setProperty('--announcement-height',(announcement?.getBoundingClientRect().height||0)+'px');
    const onScroll=()=>header.classList.toggle('is-scrolled',window.scrollY>80);
    window.addEventListener('scroll',onScroll,{passive:true,signal:headerAbort.signal});
    if(announcement&&'ResizeObserver' in window){headerObserver=new ResizeObserver(measure);headerObserver.observe(announcement);}
    measure();onScroll();
  }
  document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('[data-frame-header]'))initializeHeader();});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('[data-frame-header]')){headerAbort?.abort();headerObserver?.disconnect();}});
  initializeHeader();
})();

